
import React from "react";
import AIChatPrompt from "../../common/AIChatPrompt/AIChatPrompt";


interface ProjectEstimateAIAssistantProps {
  open?: boolean; // Now optional for backward compatibility
}

const ProjectEstimateAIAssistant: React.FC<ProjectEstimateAIAssistantProps> = ({ open }) => {
  const [step, setStep] = React.useState<'intro' | 'thinking'>('intro');

  const handleYesPlease = () => {
    setStep('thinking');
  };

  return (
    <div style={{ padding: 24 }}>
      <h3>AI Review Assistant</h3>
      <AIChatPrompt animate={open !== undefined ? open : true}>
        {step === 'intro' ? (
          <>
            <p>
              Hi there! I'm an AI tool here to help you review your project estimate and spot possible improvements.
            </p>
            <p>
              Just a heads-up: I'm not human, and my suggestions are meant to support you—not make decisions. Make sure to check everything with your team before making changes.
            </p>
            <p>
              Would you like me to analyze your current estimate and provide feedback on potential improvements or areas of concern?
            </p>
            <div style={{ marginTop: 32, display: 'flex', justifyContent: 'flex-end' }}>
              <button
                type="button"
                onClick={handleYesPlease}
                style={{
                  background: '#6366f1',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 6,
                  padding: '10px 28px',
                  fontWeight: 600,
                  fontSize: 16,
                  boxShadow: '0 2px 8px #6366f122',
                  cursor: 'pointer',
                  transition: 'background 0.2s',
                }}
              >
                Yes please
              </button>
            </div>
          </>
        ) : (
          <div>
            <p>Alright, let's get started! Give me a couple of moments to let me review your estimate. It might take a while, so hang on...
            </p>
            <div style={{textAlign:'center'}}>
              <span style={{ display: 'inline-block', width: 52, height: 52, marginLeft: 0, marginTop:20, verticalAlign: 'middle' }}>
                <svg viewBox="0 0 50 50" style={{ width: 52, height: 52 }}>
                  <circle cx="25" cy="25" r="20" fill="none" stroke="#6366f1" strokeWidth="5" strokeDasharray="31.4 31.4" strokeLinecap="round">
                    <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.9s" repeatCount="indefinite" />
                  </circle>
                </svg>
              </span>
            </div>
          </div>
        )}
      </AIChatPrompt>
      {/* TODO: Implement AI review logic and UI here */}
    </div>
  );
};

export default ProjectEstimateAIAssistant;
